export default "__VITE_ASSET__be76edf3__"